/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordstrengthweak2Inputs */

const en_passwordstrengthweak2 = /** @type {(inputs: Passwordstrengthweak2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weak`)
};

const de_passwordstrengthweak2 = /** @type {(inputs: Passwordstrengthweak2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwach`)
};

/**
* | output |
* | --- |
* | "Weak" |
*
* @param {Passwordstrengthweak2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordstrengthweak2 = /** @type {((inputs?: Passwordstrengthweak2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordstrengthweak2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordstrengthweak2(inputs)
	return de_passwordstrengthweak2(inputs)
});
export { passwordstrengthweak2 as "passwordStrengthWeak" }